@if (!gloveMode) {
    <div class="c-container d-flex justify-content-center align-items-center flex-column c-pt-48">
        <div class="intro-container d-flex justify-content-center">
            <div class="mascot c-mb-32">
                <img [src]="mascotImage" />
            </div>
            <div class="thinking-clouds">
                <ng-container [ngTemplateOutlet]="thinkingClouds"></ng-container>
            </div>
            <div class="typing-card">
                <p class="c-mb-0 typing-animation">
                    Congratulations! You got 3 subscribers. Every
                </p>
                <p class="c-mb-0 typing-animation delayed">
                    great author started with just a few fans!
                </p>
            </div>
        </div>
    </div>
    <div *ngIf="cardsVisible" class="c-container d-flex justify-content-center align-items-center flex-column c-pt-48">
        <div [@fadeIn] class="align-self-start c-pb-16">
            <div class="d-flex align-items-center c-mb-20">
                <span class="quests-header c-me-8">Your first 3 subscribers quest</span>
                <span class="c-me-8">
                    ·
                </span>
                <span class="text-secondary">1 / 1 step complete</span>
            </div>
    
            <div class="quests position-relative" [@slideInFromRight]>
                <div class="indicator">
                    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="13" cy="12.5" r="11.5" fill="#05B44B" stroke="#DDE3E8" stroke-width="2" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M17.6733 9.63618C17.7807 9.52879 17.7807 9.35467 17.6733 9.24727L16.5066 8.08055C16.3992 7.97315 16.2251 7.97315 16.1177 8.08055L11.3883 12.8099L9.51142 10.9329C9.40403 10.8255 9.22991 10.8255 9.12252 10.9329L7.95579 12.0997C7.8484 12.2071 7.8484 12.3812 7.95579 12.4886L11.1907 15.7235C11.2981 15.8309 11.4722 15.8309 11.5796 15.7235L11.6832 15.6199C11.6967 15.6106 11.7096 15.5999 11.7216 15.5879L17.6733 9.63618Z"
                            fill="white" />
                    </svg>
                </div>
                <div class="cards-container">
                    <div class="quest-card">
                        <div class="d-flex align-items-center c-gap-16">
                            <div class="listing-image" style="margin-left: -8px">
                                <img [src]="img" height="160" />
                            </div>
                            <div class="texts d-flex flex-column align-self-start">
                                <span class="main">
                                    Get your first 3 subscribers
                                </span>
                                <span class="secondary">
                                    Your author platform begins with reader connections. Complete this quest to build your email list and grow your fanbase.
                                </span>
                            </div>
                        </div>
                        <div class="actions">
                            <ng-lottie id="door" [options]="doorOptions"></ng-lottie>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="cardsVisible" [@fadeIn] class="w-100 c-btn-container d-flex justify-content-center c-mt-40 c-mb-20" >
        <button class="c-btn dark" style="width: 380px" (click)="continue()">Continue</button>
    </div>
}
@else {
    <div class="w-100 glove-container d-flex flex-column justify-content-center align-items-center">
        <ng-lottie [options]="gloveOptions"></ng-lottie>
        <div class="c-mb-80 glove-text">
            You've earned the Storyteller's Gauntlet!
        </div>
        <button class="c-btn dark" style="width: 380px" (click)="finish()">Finish</button>
    </div>
}


<ng-template #thinkingClouds>
    <svg
        width="50"
        height="50"
        viewBox="0 0 30 30"
        fill="#E3F2FD"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_541_15909)">
            <path
                d="M11.1833 22.1015C9.30989 23.2721 6.84214 22.7024 5.67147 20.829C4.50081 18.9555 5.07053 16.4878 6.94399 15.3171C8.81745 14.1464 11.2852 14.7162 12.4559 16.5896C13.6265 18.4631 13.0568 20.9308 11.1833 22.1015Z"
                fill="white"
            />
            <path
                d="M10.9184 21.6775C9.27912 22.7018 7.11984 22.2033 6.09551 20.564C5.07117 18.9247 5.56968 16.7655 7.20896 15.7411C8.84823 14.7168 11.0075 15.2153 12.0318 16.8546C13.0562 18.4939 12.5577 20.6531 10.9184 21.6775Z"
                stroke="#DDE3E8"
            />
        </g>
        <g filter="url(#filter1_d_541_15909)">
            <path
                d="M18.4977 18.7102C14.7508 21.0515 9.81526 19.912 7.47393 16.1651C5.1326 12.4182 6.27205 7.48272 10.019 5.14139C13.7659 2.80006 18.7014 3.93951 21.0427 7.68642C23.384 11.4333 22.2446 16.3688 18.4977 18.7102Z"
                fill="white"
            />
            <path
                d="M18.2327 18.2861C14.72 20.4811 10.093 19.4129 7.89796 15.9002C5.70296 12.3875 6.7712 7.76043 10.2839 5.56543C13.7967 3.37043 18.4237 4.43866 20.6187 7.95139C22.8137 11.4641 21.7454 16.0912 18.2327 18.2861Z"
                stroke="#DDE3E8"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_541_15909"
                x="4.06311"
                y="14.7087"
                width="10.0011"
                height="11.0011"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="0.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.584314 0 0 0 0 0.627451 0 0 0 0 0.698039 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_541_15909"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_541_15909"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_541_15909"
                x="5.25726"
                y="3.92471"
                width="18.0021"
                height="19.0021"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="0.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.584314 0 0 0 0 0.627451 0 0 0 0 0.698039 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_541_15909"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_541_15909"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
</ng-template>
